import { Chip } from "@mui/material";
import { Link } from "react-router-dom";

const ManagerButton = (props) => {
  return (
    <Chip
      data-testid="managerButton"
      label="Manager"
      component={Link}
      to={"/manager/" + props.managerId}
      clickable
      variant="outlined"
      sx={{ m: 0.5 }}
    />
  );
};

export default ManagerButton;
